// extracted by mini-css-extract-plugin
export var userCountItemDisabled = "user-count-item_disabled_SEmdngbwGyTiEZ63KWkK";
export var userCountItemLabel = "user-count-item__label_Eqed_lZLkauXuAXRmuMi";
export var userCountItemValue = "user-count-item__value_HXAqN8VKCAysrpHlV5fh";